import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.open,
      "max-width": "75%"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._t("title", function () {
          return [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.title')) + "\n    ")];
        })];
      },
      proxy: true
    }], null, true)
  }, [_c('div', [_c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "7"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.description')))])]), _c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "5"
    }
  }, [_c('core-date-time-picker-flat', {
    attrs: {
      "isRange": "",
      "initialRange": "now-7d"
    },
    on: {
      "date:picked": _vm.handleDateChange
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "showOperatorDropdown": "",
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "pt-4 pb-6",
    attrs: {
      "cols": "12"
    }
  }, [_c(VDivider)], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "py-0 pb-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('span', {
    staticClass: "chart-title"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.rolledOutPerConnector')))]), _vm.rolledOutPerConnector.individual ? _c('div', {
    class: `chart-wrapper ${_vm.hasRolledOutPerConnectorResults ? '' : 'chart-wrapper--no-data'}`
  }, [_c('niota-classic-charts-bar', {
    staticClass: "vd-statistics",
    attrs: {
      "height": 360,
      "multi-chart-data-t": _vm.rolledOutPerConnector,
      "options": _vm.chartConfig
    }
  }), !_vm.hasRolledOutPerConnectorResults ? _c('div', {
    staticClass: "chart-empty-state"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.noDataEmpty')) + "\n          ")]) : _vm._e(), _c('div', {
    staticClass: "mt-6"
  }, _vm._l(_vm.rolledOutPerConnector.individual, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "chart-legend"
    }, [_c('div', {
      staticClass: "color-block",
      style: `background: ${item.color}`
    }), _vm._v("\n              " + _vm._s(item.label) + "\n            ")]);
  }), 0)], 1) : _c('div', {
    staticClass: "chart-placeholder"
  }, [_vm.rolledOutPerConnector.error ? _c('div', {
    staticClass: "chart-empty-state"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.noDataError')) + "\n          ")]) : _vm._e()])]), _c(VCol, {
    staticClass: "py-0 pb-2",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('span', {
    staticClass: "chart-title"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.rolledOutPerAccount')))]), _vm.rolledOutPerAccount.individual ? _c('div', {
    class: `chart-wrapper ${_vm.hasRolledOutPerAccountResults ? '' : 'chart-wrapper--no-data'}`
  }, [_c('niota-classic-charts-bar', {
    staticClass: "vd-statistics",
    attrs: {
      "height": 360,
      "multi-chart-data-t": _vm.rolledOutPerAccount,
      "options": _vm.chartConfig
    }
  }), !_vm.hasRolledOutPerAccountResults ? _c('div', {
    staticClass: "chart-empty-state"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.noDataEmpty')) + "\n          ")]) : _vm._e(), _c('div', {
    staticClass: "mt-6"
  }, _vm._l(_vm.rolledOutPerAccount.individual, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "chart-legend"
    }, [_c('div', {
      staticClass: "color-block",
      style: `background: ${item.color}`
    }), _vm._v("\n              " + _vm._s(item.label) + "\n            ")]);
  }), 0), !_vm.accountsLoaded ? _c('div', {
    staticClass: "accounts-not-loaded-info"
  }, [_c('p', [_c(VIcon, {
    attrs: {
      "small": "",
      "color": "error"
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.accountsDataMissing')) + "\n            ")], 1)]) : _vm._e()], 1) : _c('div', {
    staticClass: "chart-placeholder"
  }, [_vm.rolledOutPerAccount.error ? _c('div', {
    staticClass: "chart-empty-state"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.statistics.noDataError')) + "\n          ")]) : _vm._e()])])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };